<template>
  <div>
    <div class="d-flex justify-center mb-40px">
      <div class="gauge-container no-shrink" ref="gaugecontainer" @click="(event) => setNeedleClick(event)">
        <div class="gauge-blue-container" ref="gaugeBlueContainer"></div>
        <div class="trapezoid-group" ref="trapezoidGroup"></div>
        <div class="gauge-lines" ref="gaugeLines"></div>
        <div class="gauge-shadow"></div>
        <div class="gauge-white-container"></div>
        <div class="triangle-needle" ref="gaugeNeedle" @drag="(event) => turnNeedle(event)"
          @dragend="(event) => setNeedle(event)"></div>
        <div class="gauge-center-needle"></div>
        <div class="gauge-center-needle-white" ref="gaugeNeedleCenter"></div>
        <input type="number" class="gauge-input" v-model="gaugeValue"  @keyup="moveNeedle()"
          @input="checkError();$emit('update:modelValue', this.gaugeValue)" />
          <div class="d-flex justify-center mt-20px label-month">
            Mois
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/mixins/utils.js";
export default {
  data() {
    return {
      gaugeValue: 0,
      error:null,
    };
  },
  mixins: [utils],
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 12,
    },
    step: {
      type: Number,
      default: 1,
    },
    modelValue: Number
  },
  methods: {
    createGauge() {
      let gauge = this.$refs.gaugecontainer;
      for (let i = this.min; i <= this.max; i++) {
        //Get angle
        const startAngle = (3 * Math.PI) / 4;
        const endAngle = 2 * Math.PI + Math.PI / 4; // 360 degrees
        const numPoints = (this.max - this.min) / this.step;
        const angleIncrement = (endAngle - startAngle) / numPoints;
        let angle = 0;
        angle = startAngle + i * angleIncrement;
        //Get radius
        this.$refs.gaugeBlueContainer.style.height='400px'
          this.$refs.gaugeBlueContainer.style.width='400px'
        let radius = this.$refs.gaugeBlueContainer.getBoundingClientRect().height / 2 + 25;
        //Get position
        const x = radius * Math.cos(angle) - 12;
        const y = radius * Math.sin(angle) - 20;
        //Create number label
        let gaugeNumber = document.createElement("div");
        let node = document.createTextNode(i);
        gaugeNumber.style['-webkit-transform'] = "translate(" + x + "px, " + y + "px )";
        gaugeNumber.style.transform = `translate(${x}px, ${y}px)`;
        gaugeNumber.style.transformOrigin = "center center";
        gaugeNumber.className = "gauge-number";
        gaugeNumber.appendChild(node);
        gauge.appendChild(gaugeNumber);
        //Create line
        if (i !== this.min && i < this.max) {
          let line = document.createElement("div");
          let radiusLine = radius - 25;
          line.style.width = radiusLine + "px";
          line.className = "gauge-line";
          line.style.transform =
            "rotate(" + this.radiansToDegrees(angle) + "deg)";
          this.$refs.gaugeLines.appendChild(line);
        }

        //Create box
        if (i < this.max && i !== this.min && i !== this.max - this.step) {
          let trapezoid = document.createElement("div");
          trapezoid.className = "trapezoid";
          trapezoid.style.transform =
            "translateX(-50%) rotate(" +
            this.radiansToDegrees(angle + angleIncrement / 2 - Math.PI / 2) +
            "deg)";
          this.$refs.trapezoidGroup.appendChild(trapezoid);
        } else if (i === this.min) {
          let circle = document.createElement("div");
          circle.className = "circle-end";
          const angle = startAngle + (i + 2) * angleIncrement;
          const x = 190 * Math.cos(angle);
          const y = 190 * Math.sin(angle);
          circle.style.transform = "translate(" + x + "px, " + y + "px )";
          this.$refs.trapezoidGroup.appendChild(circle);
        } else if (i === this.max - this.step) {
          let circle = document.createElement("div");
          circle.className = "circle-end";
          const angle = startAngle + (i - 1) * angleIncrement;
          const x = 90 * Math.cos(angle);
          const y = 90 * Math.sin(angle);
          circle.style.transform = "translate(" + x + "px, " + y + "px )";
          this.$refs.trapezoidGroup.appendChild(circle);
        }

      }
      //Set needle
      this.moveNeedle();
    },
    moveNeedle() {
      const startAngle = (3 * Math.PI) / 4;
      const endAngle = 2 * Math.PI + Math.PI / 4; // 360 degrees
      const numPoints = (this.max - this.min) / this.step;
      const angleIncrement = (endAngle - startAngle) / numPoints;
      let angle = 0;
      angle = this.gaugeValue * angleIncrement + Math.PI + Math.PI / 4;
      let degreeAngle = this.radiansToDegrees(angle);
      this.$refs.gaugeNeedle.style.transform =
        "translate(-50%, -100%) rotate(" + degreeAngle + "deg)";
      this.colorRetroAction()
    },
    getNeedleAngle(event) {
      const fixedPoint = this.$refs.gaugeNeedleCenter;
      const mouseX = event.clientX;
      const mouseY = event.clientY;
      const box = fixedPoint.getBoundingClientRect();
      const xCenter = (box.left + box.right) / 2;
      const yCenter = (box.top + box.bottom) / 2;
      let angleRadians = Math.atan2(mouseY - yCenter, mouseX - xCenter);
      if (angleRadians < 0) {
        angleRadians += 2 * Math.PI;
      }
      angleRadians += (2 * Math.PI) / 4;
      const angleDegrees = this.radiansToDegrees(angleRadians);
      return angleDegrees;
    },
    getValueFromNeedle(event) {
      let needleAngle = this.getNeedleAngle(event);
      const startAngle = (3 * Math.PI) / 4;
      const endAngle = 2 * Math.PI + Math.PI / 4; // 360 degrees
      const numPoints = (this.max - this.min) / this.step;
      const angleIncrement = (endAngle - startAngle) / numPoints;
      let value = 0;
      let lastDifferenceAngle = 0;
      for (let i = this.min; i <= this.max; i++) {
        let angle = startAngle + i * angleIncrement;
        if (needleAngle - 90 > 0 && needleAngle < 135) {
          needleAngle += 360
        }
        let difference = Math.abs(
          needleAngle - 90 - this.radiansToDegrees(angle)
        );
        if (difference < lastDifferenceAngle || lastDifferenceAngle === 0) {
          value = i;
          lastDifferenceAngle = difference;
        }
      }
      this.gaugeValue = value;
    },
    turnNeedle(event) {
      let angleDegrees = this.getNeedleAngle(event);
      this.$refs.gaugeNeedle.style.transform =
        "translate(-50%, -100%) rotate(" + angleDegrees + "deg)";
    },
    setNeedle(event) {
      this.getValueFromNeedle(event);
      this.moveNeedle();
      this.colorRetroAction()
      this.checkError()
      this.$emit('update:modelValue', this.gaugeValue)
    },
    setNeedleClick(event) {
      this.getValueFromNeedle(event);
      this.moveNeedle();
      this.colorRetroAction()
      this.checkError()
      this.$emit('update:modelValue', this.gaugeValue)
    },
    colorRetroAction() {
      let circles = document.querySelectorAll('.circle-end')[1]
      circles.style.backgroundColor = '#97d3dd'
      if (this.gaugeValue > this.min) {
        let circles = document.querySelector('.circle-end')
        circles.style.backgroundColor = '#8EC89C'
      }
      else{
        let circles = document.querySelector('.circle-end')
        circles.style.backgroundColor = '#97d3dd'
      }
      let allSection = document.getElementsByClassName("trapezoid");
      Array.from(allSection).forEach((element, index) => {
        if (index + 1 < this.gaugeValue) {
          element.style.borderBottomColor = '#8EC89C'
        }
        else {
          element.style.borderBottomColor = '#97d3dd'
        }
      });
      if (this.gaugeValue >= this.max) {
        let circles = document.querySelectorAll('.circle-end')[1]
        circles.style.backgroundColor = '#8EC89C'
      }

    },
    checkError(){
      if(this.gaugeValue==0){
        this.error='Vous devez minimalement compenser un mois'
        this.$emit('onError', true)
      }
      else{
        this.error=null
        this.$emit('onError', false)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      if(newVal>12){
        newVal=12
      }
      this.gaugeValue = newVal;
    }
  },
  mounted() {
    this.gaugeValue = this.modelValue
    this.createGauge();
  },
};
</script>
<style>
.label-month{
    color: var(--text-color);
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
}
.gauge-container {
  height: 500px;
  width: 500px;
  background-color: white;
  filter: drop-shadow(4px 4px 24px rgba(0, 0, 0, 0.15));
  border-radius: 100%;
  position: relative;
}

.gauge-blue-container {
  height: 400px;
  width: 400px;
  background-color: #03b5c6;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gauge-shadow {
  height: 360px;
  width: 360px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 20px solid rgba(0, 0, 0, 0.2);
}

.gauge-white-container {
  height: 200px;
  width: 200px;
  background-color: white;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gauge-number {
  position: absolute;
  top: 50%;
  left: 50%;
  color: var(--text-color);
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  font-family: var(--font);
}

.gauge-input {
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translateX(-50%);
  border: none;
  width: 110px;
  height: 130px;
  text-align: center;
  font-family: var(--font);
  color: var(--text-color);
  font-size: 42px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background-color: #f5f5f5;
}

.gauge-center-needle {
  height: 40px;
  width: 40px;
  background-color: #3b3b3c;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.gauge-center-needle-white {
  height: 15px;
  width: 15px;
  background-color: white;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
}

.triangle-needle {
  width: 0;
  height: 0;
  border-left: 20.5px solid transparent;
  border-right: 20.5px solid transparent;
  border-bottom: 70px solid #3b3b3c;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  transform-origin: bottom center;
  transition-timing-function: ease-in;
  cursor: pointer;
}

.gauge-lines {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gauge-line {
  background-color: #03b5c6;
  height: 2px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: top left;
}

.trapezoid-group {
  width: 100%;
  height: 100%;
  clip-path: circle(198px at center);
}

.trapezoid {
  width: 0;
  height: 0;
  border-left: 32px solid transparent;
  border-right: 32px solid transparent;
  border-bottom: 200px solid #97d3dd;
  /* You can change the background color */
  padding-left: 5px;
  padding-right: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: top center;
  transform: translateX(-50%);
  z-index: 200;
}

.circle-end {
  height: 100px;
  width: 100px;
  background-color: #97d3dd;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
}

@media (max-width: 800px) {
  .gauge-container {
    transform: scale(0.7);
  }
}

@media (max-width: 500px) {
  .gauge-container {
    transform: scale(0.5);
  }
}
</style>
